// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CardSampleView_custom1__1iSAT {
  margin: 20px;
  padding: 0;
}

.CardSampleView_header1__UakRc {
  background-color: #000;
  color: #fff;
  margin: 0;
  padding-bottom: 5px;
}

.CardSampleView_footer1__\\+bonu {
  background-color: #ccc;
  color: blue;
  margin: 0;
  padding-bottom: 5px;
}

.CardSampleView_picture__R2OmY {
  max-width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/examples/views/CardSampleView/CardSampleView.module.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,UAAA;AACF;;AAEA;EACE,sBAAA;EACA,WAAA;EACA,SAAA;EACA,mBAAA;AACF;;AAEA;EACE,sBAAA;EACA,WAAA;EACA,SAAA;EACA,mBAAA;AACF;;AAEA;EACE,eAAA;AACF","sourcesContent":[".custom1 {\n  margin: 20px;\n  padding: 0;\n}\n\n.header1 {\n  background-color: #000;\n  color: #fff;\n  margin: 0;\n  padding-bottom: 5px;\n}\n\n.footer1 {\n  background-color: #ccc;\n  color: blue;\n  margin: 0;\n  padding-bottom: 5px;\n}\n\n.picture {\n  max-width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"custom1": `CardSampleView_custom1__1iSAT`,
	"header1": `CardSampleView_header1__UakRc`,
	"footer1": `CardSampleView_footer1__+bonu`,
	"picture": `CardSampleView_picture__R2OmY`
};
export default ___CSS_LOADER_EXPORT___;
